'use strict';

class PlayerShot {
  constructor() {
    this.active = false;
    this.x = 0;
    this.y = 0;
    this.speed = 0;
    this.damage = 1;
    this.radius = 6;
    this.length = 30;
  }

  reset(options) {
    this.active = true;
    this.x = Number(options.x) || 0;
    this.y = Number(options.y) || 0;
    this.speed = Math.max(0, Number(options.speed) || 0);
    this.damage = Math.max(1, Number(options.damage) || 1);
    return this;
  }

  update(dt, bounds) {
    if (!this.active) return;
    this.y -= this.speed * dt;
    if (this.y + this.length < bounds.top) this.active = false;
  }

  draw(ctx) {
    if (!this.active) return;
    ctx.save();
    ctx.strokeStyle = '#ffffff';
    ctx.shadowColor = '#46e6ff';
    ctx.shadowBlur = 14;
    ctx.lineWidth = 7;
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(this.x, this.y + this.length / 2);
    ctx.lineTo(this.x, this.y - this.length / 2);
    ctx.stroke();
    ctx.restore();
  }

  getHitCircle() {
    return { x: this.x, y: this.y, radius: this.radius };
  }
}

module.exports = PlayerShot;
